import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-common';

import { getContentWidth } from './contentWidthCss';
import type { WidthOptions } from './contentWidthCss';

export const getActionsCss = (options: WidthOptions) => {
  return css`
    padding: var(--cds-spacing-600) var(--cds-spacing-600);

    ${breakpoints.down('sm')} {
      padding: var(--cds-spacing-400) var(--cds-spacing-200);
    }

    ${getContentWidth(options)}
  `;
};
